import { lightComponentColors } from "./componentColors";

// A crisp, mostly-white surface with the faintest violet wash in the corners —
// Stripe-clean, but a touch more colourful thanks to the soft purple tints.
const snowCanvas =
  "radial-gradient(1200px 600px at 100% 0%, rgba(124,58,237,0.06) 0%, transparent 60%), radial-gradient(1000px 500px at 0% 100%, rgba(99,91,255,0.05) 0%, transparent 55%), linear-gradient(180deg, #ffffff 0%, #fbfaff 100%)";

const snowSurface =
  "linear-gradient(135deg, rgba(124,58,237,0.05) 0%, rgba(255,255,255,0.9) 45%), #ffffff";

const snowSelectedSurface =
  "linear-gradient(135deg, rgba(124,58,237,0.12) 0%, rgba(255,255,255,0.95) 60%), #ffffff";

export const lemmonSnow = {
  lemmonSnow: {
    "color-scheme": "light",
    // Purple stays the brand: primary is the main payment action (Card/Twint)
    // and accent is the brand highlight used for the TOTAL, headers and the
    // Rewards button. The utility buttons (Tips/discounts, cash/manual/QR) use
    // neutral slates instead of more purple, so the screen reads as "purple
    // brand + calm greys" rather than a wall of purple.
    primary: "#7c3aed",
    "primary-content": "#ffffff",

    secondary: "#475569",
    "secondary-content": "#ffffff",

    accent: "#6366f1",
    "accent-content": "#ffffff",

    neutral: "#1e293b",
    "neutral-content": "#ffffff",

    "base-100": "#ffffff",
    "base-200": "#faf9ff",
    "base-300": "#f1eefc",
    "base-content": "#1e1b2e",
    "--font-family": "'Open Sans', sans-serif",
    "--body-bg-color": snowCanvas,
    "--form-control-background": "#f6f4fe",
    "--lemmon-switcher-background": "#f1eefc",
    "--lemmon-switcher-border": "#e5e0f8",
    "--lemmon-switcher-indicator-background": "#ffffff",
    "--lemmon-switcher-indicator-overlay-background": "rgba(124, 58, 237, 0.06)",
    "--lemmon-switcher-indicator-shadow": "rgba(76, 29, 149, 0.12) 0px 1px 3px",

    info: "#0ea5e9",
    "info-content": "#001824",
    success: "#16a34a",
    "success-content": "#ffffff",
    warning: "#d97706",
    "warning-content": "#1a1300",
    error: "#e11d48",
    "error-content": "#ffffff",

    "--pos-card-bg": snowSurface,
    "--pos-card-selected-bg": snowSelectedSurface,
    "--pos-bar-color": "#4c1d95",
    "--pos-panel-bg": "#faf9ff",
    "--pos-border-color": "#e5e0f8",
    "--pos-shadow-color": "rgba(76,29,149,0.10)",
    "--pos-shadow-highlight": "rgba(255,255,255,0.9)",
    ...lightComponentColors,
    "--floor-plan-background": snowCanvas,
    "--floor-plan-grid-line": "rgba(124,58,237,0.10)",
    "--floor-plan-grid-padding": "rgba(124,58,237,0.04)",
    "--floor-plan-section-divider": "rgba(124,58,237,0.14)",
    "--floor-plan-selection-background": "rgba(124,58,237,0.18)",
    "--floor-plan-selection-border": "#7c3aed",
    "--floor-plan-fixture-background": "#efeafc",
    "--floor-plan-fixture-content": "#3f3f5a",
    "--floor-plan-fixture-shadow":
      "0 2px 8px rgba(76,29,149,0.12), inset 0 1px 0 rgba(255,255,255,0.85)",
    "--floor-plan-table-free-background": "#ece7fb",
    "--floor-plan-table-free-content": "#2e2a45",
    "--floor-plan-table-free-shadow":
      "0 2px 8px rgba(76,29,149,0.12), inset 0 1px 0 rgba(255,255,255,0.75)",
    "--floor-plan-table-busy-background": "#7c3aed",
    "--floor-plan-table-busy-content": "#ffffff",
    "--floor-plan-table-busy-shadow":
      "0 3px 10px rgba(124,58,237,0.28), inset 0 1px 0 rgba(255,255,255,0.18)",
    "--order-card-background": "#ffffff",
    "--order-filter-header-background": "var(--order-card-background)",
    "--order-filter-control-background": "#f6f4fe",
    "--order-card-border": "#e5e0f8",
    "--order-card-section-border": "rgba(124,58,237,0.12)",
    "--order-card-muted-content": "#6b6785",
    "--order-card-dine-in-background": "#475569",
    "--order-card-takeaway-background": "#ede9fe",
    "--order-card-takeaway-content": "#4c1d95",
    "--floor-plan-walker-accent": "#7c3aed",
    "--floor-plan-walker-accent-alt": "#6366f1",
  },
};
